import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { normalizeAnalyticsPath, trackPageView } from "../analytics";

export default function AnalyticsPageView() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(normalizeAnalyticsPath(location.pathname));
  }, [location.pathname]);
  return null;
}
